"use strict";
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DaySetting = void 0;
/**
 * 空间日期设置
 */
var DaySetting;
(function (DaySetting) {
    DaySetting["MON"] = "MON";
    DaySetting["SUN"] = "SUN";
})(DaySetting = exports.DaySetting || (exports.DaySetting = {}));
